import { render, staticRenderFns } from "./slideitem.vue?vue&type=template&id=fb0c4826&scoped=true&"
import script from "./slideitem.vue?vue&type=script&lang=js&"
export * from "./slideitem.vue?vue&type=script&lang=js&"
import style0 from "./slideitem.vue?vue&type=style&index=0&id=fb0c4826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0c4826",
  null
  
)

export default component.exports